import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap-5';
import { isPresent } from 'helpers/string_helpers';

const EmptyState = (props) => {
  const message = typeof(props.message) === 'string'
    ? <div>{props.message}</div>
    : props.message;
  const image = isPresent(props.imageSrc)
    ? <img alt="" className="mb-4" src={props.imageSrc} style={{ height: 40 }}/>
    : null;

  const body = (
    <>
      {image}
      {message}
      {props.subMessage &&
        <div className="text-muted">{props.subMessage}</div>
      }
    </>
  );

  if (props.wrapInPanel) {
    return (
      <Card className="text-center border-dashed">
        <Card.Body>{body}</Card.Body>
      </Card>
    );
  }

  return (
    <div className="text-center p-5">{body}</div>
  );
};

EmptyState.propTypes = {
  imageSrc: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  wrapInPanel: PropTypes.bool
};

export default EmptyState;
